// extracted by mini-css-extract-plugin
export default {"root":"_3at5n","content":"_2G6C4"};